import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useMutation, useQueryClient } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import { settlementRequestBySupplier } from "../../services/supplier.service";
import {
  SettlementRequestBySupplierRequest,
  SettlementRequestBySupplierResponse,
} from "../../models/supplier.model";
import { Formik } from "formik";
import * as Yup from "yup";
import { Checkbox, FormControlLabel, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SwitchCmp from "../switch/SwitchCmp";
import PrintComponent from "../../pages/detail/tabs/printComponent";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalPrint({
  openModel,
  setOpenValidationModel,
  printedData,
  id,
}: any) {
  const history = useHistory();

  const [open, setOpen] = React.useState<boolean>(openModel);
  const [printedDataState, setPrintedDataState] = React.useState<any>(
    printedData
  );
  React.useEffect(() => {
    setOpen(openModel);
    if (openModel) {
      setPrintedDataState(printedData);
    }
  }, [openModel]);

  React.useEffect(() => {
    setPrintedDataState(printedData);
  }, [printedData]);

  const handleClose = () => {
    setOpen(false);
    setOpenValidationModel(false);
  };
  const validationFatcorNumber = Yup.object().shape({});

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    let findedItem = printedDataState.find(
      (item: any) => item.key === event.target.name
    );
    findedItem.showComponent = event.target.checked;
    if (findedItem.justDocuments == true) findedItem.showDocuments = true;

    setPrintedDataState([...printedDataState]);
  };
  const handleSwitchButton = (selectedItem: any, checked: boolean) => {
    let findedItem = printedDataState.find(
      (item: any) => item.key === selectedItem
    );
    findedItem.showDocuments = checked;
    setPrintedDataState([...printedDataState]);
  };

  const openPrintComponent = () => {
    window.sessionStorage.setItem("id", id);
    history.push({
      pathname: `/loan/printPreview`,
      state: { printedDataState, id },
    });
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          validateOnMount={true}
          initialValues={printedData}
          validationSchema={validationFatcorNumber}
          onSubmit={async (values) => {
            // setOpenValidationModel(false)
            // setShowPrint(true);
            openPrintComponent();
            // setTimeout(function () {
            //     window.print()
            // }, 1000);
          }}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box
                sx={style}
                style={{ borderRadius: "6px", marginTop: "6vh" }}
                className="PrintModalCmp textCenter "
              >
                <IconButton onClick={handleClose}>
                  <CloseIcon
                    style={{
                      position: "fixed",
                      zIndex: "1",
                      left: "1vh",
                      color: "red",
                      top: "1vh",
                    }}
                  />
                </IconButton>
                <span className="colorTitle  textFont18 fontWeight">
                  بخش های مورد نظر برای نسخه چاپی را انتخاب و روی دکمه دریافت
                  پرونده کلیلک کنید.
                </span>

                <Grid
                  container
                  spacing={2}
                  xs={12}
                  style={{ marginTop: "5vh" }}
                  className="colorTitle  textFont14"
                >
                  {printedDataState.map((item: any, key: number) =>
                    item.showItemInModal ? (
                      <Grid item xs={6} style={{ border: "1px solid #DAE0E4" }}>
                        <Grid container spacing={2} xs={12}>
                          <Grid
                            item
                            xs={6}
                            style={{
                              direction: "rtl",
                              alignItems: "flex-end",
                              display: "flex",
                              marginTop: "-0.4vh",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  defaultChecked={
                                    item.key == "Identity" ||
                                    item.key == "selectedLoan"
                                      ? true
                                      : false
                                  }
                                  onChange={handleCheckBox}
                                  name={item.key}
                                  disabled={
                                    item.key == "Identity" ||
                                    item.key == "selectedLoan"
                                  }
                                  value={item.id}
                                  sx={{
                                    "&.Mui-disabled": { color: "#1976d2" },
                                  }}
                                />
                              }
                              label={item.title}
                              sx={{
                                "& .MuiFormControlLabel-label.Mui-disabled": {
                                  color: "#1d4a87",
                                },
                              }}
                            />
                          </Grid>

                          {item.showComponent &&
                          item.justComponent == false &&
                          item.justDocuments == false ? (
                            <>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  direction: "rtl",
                                  alignItems: "flex-end",
                                  display: "flex",
                                  maxHeight: "50px",
                                  minHeight: "50px",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={2}
                                  xs={12}
                                  style={{
                                    maxHeight: "50px",
                                    minHeight: "50px",
                                  }}
                                >
                                  <Grid
                                    item
                                    xs={10}
                                    style={{ marginTop: "0.5vh" }}
                                  >
                                    <span
                                      style={{
                                        marginLeft: "2vh",
                                        color: "#1d4a87",
                                      }}
                                    >
                                      |
                                    </span>
                                    <span>چاپ فایل های ضمیمه شده</span>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={2}
                                    style={{ marginTop: "-0.8vh" }}
                                  >
                                    <SwitchCmp
                                      Label={""}
                                      checked={false}
                                      onChange={(checked: boolean) => {
                                        handleSwitchButton(item.key, checked);
                                      }}
                                      onlabel={"بله"}
                                      offlabel={"خیر"}
                                      colSize="col-lg-1 col-1"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    ) : (
                      <></>
                    )
                  )}
                  <Grid container xs={12} style={{ direction: "ltr" }}>
                    <Grid item xs={3} style={{ display: "contents" }}>
                      <Button
                        type="submit"
                        className={"btnForm SuccessDefault"}
                        style={{
                          width: "200px",
                          marginRight: "1vh",
                          marginTop: "3vh",
                        }}
                      >
                        دریافت پرونده
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
